import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "card-toolbar text-center pt-5",
  "data-kt-buttons": "true"
}
const _hoisted_2 = { class: "card-header border-0 mt-2" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-trash-fill fa-sm text-primary",
  style: {"font-size":"1.5rem"}
}, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "card-label fw-bolder fs-3 mb-1"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Average Fill Level at Pick up ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-trash-fill fa-sm text-primary",
  style: {"font-size":"1.5rem"}
}, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row mt-2" }, null, -1)
const _hoisted_11 = {
  key: 2,
  class: "border border-danger p-3 mt-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6" }, "Change", -1)
const _hoisted_13 = { class: "row text-danger mt-1" }
const _hoisted_14 = { class: "col p-2 fs-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col p-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-up-arrow fa-lg text-danger" })
], -1)
const _hoisted_16 = {
  key: 3,
  class: "border border-success p-3 mt-2"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6" }, "Change", -1)
const _hoisted_18 = { class: "row text-success mt-1" }
const _hoisted_19 = { class: "col p-2 fs-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col p-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-down-arrow fa-lg text-success" })
], -1)
const _hoisted_21 = {
  key: 0,
  class: "dropdown mt-3"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary dropdown-toggle",
  type: "button",
  id: "dropdownMenu2",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " Select Building ", -1)
const _hoisted_23 = {
  class: "dropdown-menu scrollable-menu",
  "aria-labelledby": "dropdownMenu2"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card shadow-sm"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: _normalizeClass(["btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1", `${_ctx.payload.filter == '6m' ? 'active' : ''}`]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateChart('6m'))),
        id: "kt_charts_widget_2_month_btn"
      }, "6M", 2),
      _createElementVNode("a", {
        class: _normalizeClass(["btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1", `${_ctx.payload.filter == '3m' ? 'active' : ''}`]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateChart('3m'))),
        id: "kt_charts_widget_2_month_btn"
      }, "3M", 2),
      _createElementVNode("a", {
        class: _normalizeClass(["btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1", `${_ctx.payload.filter == 'month' ? 'active' : ''}`]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateChart('month'))),
        id: "kt_charts_widget_2_month_btn"
      }, "1M", 2),
      _createElementVNode("a", {
        class: _normalizeClass(["btn btn-sm btn-color-muted btn-active btn-active-primary px-4", `${_ctx.payload.filter == 'week' ? 'active' : ''}`]),
        id: "kt_charts_widget_2_week_btn",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateChart('week')))
      }, "1W", 2)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        (_ctx.isBuilding)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "card-label fw-bolder fs-3 mb-1",
              title: _ctx.bin_address
            }, [
              _createTextVNode(" Average Fill Level of (" + _toDisplayString(_ctx.bin_address) + ") ", 1),
              _hoisted_5
            ], 8, _hoisted_4))
          : _createCommentVNode("", true),
        (!_ctx.isBuilding)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_9))
          : _createCommentVNode("", true),
        _hoisted_10,
        (_ctx.increase == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.avg.percent) + "%", 1),
                _hoisted_15
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.avg.percent) + "%", 1),
                _hoisted_20
              ])
            ]))
      ]),
      (_ctx.isBuilding)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.binsList, (value, key) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: key,
                  class: _normalizeClass(`${_ctx.bin_address == key ? 'dropdown-item active' : 'dropdown-item'
          }`),
                  type: "button",
                  onClick: ($event: any) => (_ctx.updateBin(value))
                }, _toDisplayString(key), 11, _hoisted_24))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_apexchart, {
        class: "mixed-widget-10-chart",
        type: "area",
        options: _ctx.chartOptions,
        series: _ctx.series,
        id: "chart"
      }, null, 8, ["options", "series"])
    ])
  ], 2))
}